import { config } from "zod"

// CSP blocks dynamic code generation; even Zod's caught capability probe emits a violation.
config({ jitless: true })
